// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
/// <reference path="../typings/CoveoForSitecore/CoveoForSitecore.JQuery.d.ts"/>
var CoveoForSitecore = require("./CoveoForSitecore");
Coveo.initCoveoForSitecore = function (element, action, options) {
    if (action === "init") {
        CoveoForSitecore.initializeSearch(element, options);
    }
    else if (action === "initSearchbox") {
        CoveoForSitecore.initializeSearchbox(element, options);
    }
    else {
        console.error("The action '" + action + "' is not part of the coveoForSitecore plugin. Ignoring action.");
    }
};
Coveo.initializeJQuery = function (jQueryInstance) {
    Coveo.$ = jQueryInstance;
    Coveo.initializeCoveoForSitecorePlugin();
};
Coveo.initializeCoveoForSitecorePlugin = function () {
    if (typeof (Coveo.$) !== "undefined" && typeof (Coveo.$.fn) != "undefined") {
        Coveo.$.fn.coveoForSitecore = function (action, options) {
            Coveo.initCoveoForSitecore(this[0], action, options);
            return this;
        };
    }
};
(function (jQueryInstance) {
    if (typeof (jQueryInstance) !== "undefined") {
        Coveo.initializeJQuery(jQueryInstance);
    }
})(typeof (Coveo) !== "undefined" && typeof (Coveo.$) !== "undefined" ? Coveo.$ : jQuery);



//////////////////
// WEBPACK FOOTER
// ./CoveoForSitecore.JQuery.ts
// module id = 1
// module chunks = 0